import { render } from "./UserDashboard.vue?vue&type=template&id=21244b4d&scoped=true"
import script from "./UserDashboard.vue?vue&type=script&lang=js"
export * from "./UserDashboard.vue?vue&type=script&lang=js"

import "./UserDashboard.vue?vue&type=style&index=0&id=21244b4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21244b4d"]])

export default __exports__